"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRatingAndReviewWatchAll = exports.useRatingAndReviewWatch = exports.useRatingAndReviewForm = exports.FormProvider = void 0;
var _zod = require("@hookform/resolvers/zod");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _useCreateReview = require("../../api/useCreateReview");
var _useUpdateReview = require("../../api/useUpdateReview");
var _hooks = require("../../hooks");
var _ratingAndReviewDialogContext = require("../ratingAndReviewDialogContext");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file @preserve -- context

const FormProvider = ({
  children
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const form = (0, _reactHookForm.useForm)({
    defaultValues: {
      author: undefined,
      cons: {
        items: [],
        inputValue: ''
      },
      productCode: undefined,
      pros: {
        items: [],
        inputValue: ''
      },
      reviewText: undefined,
      score: 0
    },
    mode: 'all',
    resolver: (0, _zod.zodResolver)((0, _utils.getRatingAndReviewSchema)(formatMessage))
  });
  const createReview = (0, _useCreateReview.useCreateReview)();
  const updateReview = (0, _useUpdateReview.useUpdateReview)();
  const {
    reviewId
  } = (0, _ratingAndReviewDialogContext.useRatingAndReviewDialog)();
  const onSubmit = (0, _react.useCallback)(formValues => {
    if (reviewId) {
      updateReview(formValues);
    } else {
      createReview(formValues);
    }
  }, [createReview, reviewId, updateReview]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
    ...form,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
      noValidate: true,
      onSubmit: form.handleSubmit(onSubmit),
      children: children
    })
  });
};
exports.FormProvider = FormProvider;
const useRatingAndReviewForm = () => (0, _reactHookForm.useFormContext)();
exports.useRatingAndReviewForm = useRatingAndReviewForm;
const useRatingAndReviewWatch = name => {
  const {
    control
  } = useRatingAndReviewForm();
  return (0, _reactHookForm.useWatch)({
    name,
    control
  });
};
exports.useRatingAndReviewWatch = useRatingAndReviewWatch;
const useRatingAndReviewWatchAll = () => {
  const {
    control
  } = useRatingAndReviewForm();
  return (0, _reactHookForm.useWatch)({
    control
  });
};
exports.useRatingAndReviewWatchAll = useRatingAndReviewWatchAll;
